import { Chip } from '@/components/atoms';

export interface FilterOption {
  value: string;
  label: string;
}

export function FilterPillRow({
  options,
  active,
  onChange,
}: {
  options: FilterOption[];
  active: string;
  onChange: (value: string) => void;
}) {
  return (
    <div className="flex flex-wrap gap-2">
      {options.map(o => (
        <Chip key={o.value} active={o.value === active} onClick={() => onChange(o.value)}>
          {o.label}
        </Chip>
      ))}
    </div>
  );
}
